var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
// @ts-ignore
import { AppBreadcrumb, AppHeader, AppSidebar, AppSidebarFooter, AppSidebarMinimizer } from '@coreui/react'
import * as React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import { useGlobalContext } from '../../global'
import { ODLoading } from '../../loading'
import { ODFlexContentsContainer } from './container/ODFlexContentsContainer'
import { ODHeader } from './header/ODHeader'
import { ODAppSidebarNav } from './sidebar/ODAppSidebarNav'
var ODAppSidebar = styled(AppSidebar)(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      [
        '\n  // \uC0AC\uC774\uB4DC \uBA54\uB274\uC5D0\uC11C \uC120\uD0DD\uACFC hover \uB97C \uBC14\uAFD4\uC900\uB2E4.\n  .nav-link {\n    background-color: ',
        ' !important;\n    color: ',
        ' !important;\n\n    .nav-icon {\n      color: ',
        ' !important;\n    }\n  }\n\n  .nav-link.active {\n    background-color: ',
        ' !important;\n    color: ',
        ' !important;\n\n    .nav-icon {\n      color: ',
        ' !important;\n    }\n  }\n\n  .nav-link:not(.active):hover {\n    background-color: ',
        ' !important;\n    color: ',
        ' !important;\n\n    .nav-icon {\n      color: ',
        ' !important;\n    }\n  }\n',
      ],
      [
        '\n  // \uC0AC\uC774\uB4DC \uBA54\uB274\uC5D0\uC11C \uC120\uD0DD\uACFC hover \uB97C \uBC14\uAFD4\uC900\uB2E4.\n  .nav-link {\n    background-color: ',
        ' !important;\n    color: ',
        ' !important;\n\n    .nav-icon {\n      color: ',
        ' !important;\n    }\n  }\n\n  .nav-link.active {\n    background-color: ',
        ' !important;\n    color: ',
        ' !important;\n\n    .nav-icon {\n      color: ',
        ' !important;\n    }\n  }\n\n  .nav-link:not(.active):hover {\n    background-color: ',
        ' !important;\n    color: ',
        ' !important;\n\n    .nav-icon {\n      color: ',
        ' !important;\n    }\n  }\n',
      ]
    )),
  function (p) {
    return p.bg_color
  },
  function (p) {
    return p.text_color
  },
  function (p) {
    return p.icon_color
  },
  function (p) {
    return p.active_bg_color
  },
  function (p) {
    return p.active_text_color
  },
  function (p) {
    return p.active_icon_color
  },
  function (p) {
    return p.hover_bg_color
  },
  function (p) {
    return p.hover_text_color
  },
  function (p) {
    return p.hover_icon_color
  }
)
export var ODCommonMainLayout = function (props) {
  var routes = props.routes,
    navs = props.navs,
    defaultRoute = props.defaultRoute,
    _a = props.style,
    style = _a === void 0 ? {} : _a,
    renderHeader = props.renderHeader
  var _b = useGlobalContext().state.def,
    _sidebarProps = _b.sidebar,
    _c = _b.appHeader,
    topBorderColor = _c.topBorderColor,
    topBorderSize = _c.topBorderSize
  var sidebarProps = {
    bg_color: _sidebarProps.bgColor,
    icon_color: _sidebarProps.iconColor,
    text_color: _sidebarProps.textColor,
    active_bg_color: _sidebarProps.activeBGColor,
    active_icon_color: _sidebarProps.activeIconColor,
    active_text_color: _sidebarProps.activeTextColor,
    hover_bg_color: _sidebarProps.hoverBGColor,
    hover_icon_color: _sidebarProps.hoverIconColor,
    hover_text_color: _sidebarProps.hoverTextColor,
  }
  return React.createElement(
    'div',
    { className: 'app', style: { borderTop: topBorderSize + ' solid ' + topBorderColor } },
    React.createElement(
      AppHeader,
      { fixed: true },
      React.createElement(
        React.Suspense,
        { fallback: ODLoading },
        renderHeader ? renderHeader() : React.createElement(ODHeader, null)
      )
    ),
    React.createElement(
      'div',
      { className: 'app-body' },
      React.createElement(
        ODAppSidebar,
        __assign({}, sidebarProps, { fixed: true, display: 'lg' }),
        React.createElement(
          React.Suspense,
          { fallback: ODLoading },
          React.createElement(ODAppSidebarNav, { navConfig: navs, location: location })
        ),
        React.createElement(AppSidebarFooter, null),
        React.createElement(AppSidebarMinimizer, null)
      ),
      React.createElement(
        'main',
        { className: 'main', style: { display: 'flex', flexDirection: 'column' } },
        React.createElement(AppBreadcrumb, { appRoutes: routes }),
        React.createElement(
          'div',
          {
            style: __assign(
              {
                display: 'flex',
                flexGrow: 3,
                marginTop: 30,
                marginBottom: 25,
                marginLeft: 30,
                marginRight: 30,
                overflowX: 'scroll',
              },
              style
            ),
          },
          React.createElement(
            React.Suspense,
            { fallback: ODLoading },
            React.createElement(
              ODFlexContentsContainer,
              null,
              React.createElement(
                Switch,
                null,
                routes.map(function (route, idx) {
                  return route.component || route.render
                    ? React.createElement(Route, {
                        key: idx,
                        path: route.path,
                        exact: route.exact,
                        // @ts-ignore
                        name: route.name,
                        render: function (p) {
                          return route.component
                            ? React.createElement(route.component, __assign({ message: route.name }, p))
                            : route.render(p)
                        },
                      })
                    : null
                }),
                React.createElement(Redirect, { to: defaultRoute })
              )
            )
          )
        )
      )
    )
  )
}
var templateObject_1
//# sourceMappingURL=ODCommonMainLayout.js.map
